module.exports = __webpack_public_path__ + "static/img/WS-100S.9042134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/WS-100S.png
// module id = dLYp
// module chunks = 4